import React from 'react'
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleRoundedIcon from '@material-ui/icons/RemoveCircleRounded';
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { Box, Input } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => createStyles({
  button: {
    '& .minus': {
      cursor: 'pointer',
    },
    '& .percent': {
      fontSize: 14,
      fontWeight: 700,
    },
    '& .plus': {
      color: theme.palette.success.main,
      cursor: 'pointer',
    },
  },
  active: {
  },
})
);

interface OwnProps {
  readonly onChange: (percent: number) => void;
  readonly previousPercent?: number;
  readonly disableMin?: boolean;
  readonly disableMax?: boolean;
  readonly changeOverride?: number;
  readonly constantMax?: number;
  readonly constantMin?: number;
  readonly defaultPercent?: number;
}

type Props = OwnProps;

const RoiBoostButton = (props: Props) => {
  const {previousPercent, defaultPercent, disableMin, disableMax, constantMax, constantMin, changeOverride, onChange} = props;
  const classes = useStyles();
  const [percent, setPercent] = React.useState(defaultPercent || 0);
  const [inputValue, setInputValue] = React.useState(defaultPercent?.toString() || '0');
  const defaultValue = defaultPercent !== undefined ? defaultPercent : 0;
  const handleChange = (add: boolean, forceClear?: boolean) => {
    if (forceClear) {
      setPercent(0);
      setInputValue('0');
      onChange(0);
    } else if (add) {
      if(!disableMax && !(constantMax !== undefined && percent === constantMax)) {
        const amountToAdd = changeOverride ? changeOverride : 5;
        const newVal = percent + amountToAdd;
        
        setPercent(newVal);
        setInputValue(newVal.toString());
        onChange(newVal);
      }
    } else {
      if(!disableMin && !(constantMin !== undefined && percent === constantMin)){
        const amountToAdd = changeOverride ? changeOverride : 5;
        const newVal = percent - amountToAdd;
        setPercent(newVal);
        setInputValue(newVal.toString());
        onChange(newVal);
      }
    }
  }

  // const handleType = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  //   let value = event.target.value.replaceAll('%', '');
  //   setPercent(value)
  //   // onChange(parseInt(value));
  // }
  const handleBlur = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    let value = event.target.value.replaceAll('%', '');
    if (event.target.value === '') {
      setPercent(0);
      onChange(0);
      return;
    }
    if (isNaN(parseInt(value))) {
      setPercent(0);
      onChange(0);
      
      return;
    }
    setInputValue(value)
    setPercent(parseInt(value))
    onChange(parseInt(value));
  }

  React.useEffect(() => {
    if(previousPercent !== undefined && previousPercent !== percent) {
      setPercent(previousPercent);
      setInputValue(previousPercent.toString());
    }
  }, [previousPercent])

React.useEffect(() => {
  if (defaultPercent === 0 && percent !== 0) {
    handleChange(false, true) // clear all
  }
}, [defaultPercent])

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(255, 255, 255, 0.05)" padding="4px" borderRadius="6px" width="100%" className={`${classes.button} ${percent !== defaultValue && classes.active}`}>
      <RemoveCircleRoundedIcon onClick={() => handleChange(false)} color='error' className='minus'/>
      <Box display='flex' alignItems='center' color='white' className='percent' borderBottom='1px solid white'>
        <Input type="tel" value={isNaN(parseInt(inputValue)) ? inputValue : parseInt(inputValue).toString()} onChange={(e) => {
          setInputValue(e.target.value)}
          } onBlur={handleBlur} className='percent' sx={{ width: `48px`, color: 'white', display: 'flex', '& input': { textAlign: 'center'}}}></Input>
        %
      </Box>
      <AddCircleIcon onClick={() => handleChange(true)} color='action'className='plus' />
    </Box>
  )
}

export default RoiBoostButton